module.exports = "https://r.zoocdn.com/_next/static/images/hero-320-2058a1dadc5579573aff972ed8c2c699.jpg";